/*@ngInject*/
module.exports = function() {
    return {
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
            let vm = this;
            vm.size = '';
            vm.height = '';
            vm.color = '';

            vm.saveSettings = () => {
                const panelSettings = {
                    size: vm.size,
                    height: vm.height,
                    color: vm.color
                };
                localStorage.setItem('panelSettings', JSON.stringify(panelSettings));
            };

            vm.setClass = (value) => {
                vm.removeClass(value);
                if (value !== '') {
                    $('body').addClass(value);
                } else {
                    $('body').removeClass(value);
                }
            };

            vm.changeSize = function (size) {
                vm.size = size;
                vm.setClass(vm.size);
                vm.saveSettings();
            };

            vm.changeLineHeight = function (height) {
                vm.height = height;
                vm.setClass(vm.height);
                vm.saveSettings();
            };

            vm.changeColor = function (color) {
                vm.color = color;
                vm.setClass(vm.color);
                vm.saveSettings();
            };

            vm.removeClass = function(value) {
                $('body').removeClass(function (index, className) {
                    const rgxp = new RegExp(value.slice(0, -1) + '\\S', 'g');
                    return (className.match(rgxp) || []).join(' ')
                });
            };

            vm.reset = function () {
                $('.panel input').prop('checked', false);

                vm.size = '';
                vm.height = '';
                vm.color = '';
                vm.saveSettings();

                $('body').removeClass(function (index, className) {
                    var rgxp = new RegExp('(height|size|color)\\S', 'g');
                    return (className.match(rgxp) || []).join(' ')
                });
            };

            vm.close = function () {
                $('#panel-open').toggleClass('active');
                $('main').toggleClass('open-size');
                $('footer').toggleClass('open-size');
                $('.panel').slideToggle('slow', function () {
                });
            };


            if (localStorage.getItem('panelSettings')) {
                const panelSettings = JSON.parse(localStorage.getItem('panelSettings'));
                vm.size = panelSettings.size;
                vm.setClass(vm.size);
                vm.height = panelSettings.height;
                vm.setClass(vm.height);
                vm.color = panelSettings.color;
                vm.setClass(vm.color);
            }
        },
        template: require('./panel.directive.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/panel.directive.js
 **/